/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const ArrowLeft: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="arrow-left" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M623.3333333333333 340L702.6666666666666 422.1666666666667L501.4999999999999 623.3333333333334H1020V736.6666666666667H501.4999999999999L702.6666666666665 937.8333333333331L623.3333333333333 1020L283.3333333333333 680L623.3333333333333 340z" : "M498.6666666666667 272L562.1333333333333 337.7333333333333L401.2 498.6666666666666H816V589.3333333333333H401.2L562.1333333333333 750.2666666666667L498.6666666666667 816L226.6666666666667 544L498.6666666666667 272z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
ArrowLeft.displayName = `Blueprint5.Icon.ArrowLeft`;
export default ArrowLeft;
